module.exports = __webpack_public_path__ + "f8830a4b2be634d0e6320fd000ebe048.svg";